import React from 'react';
import EditorialContainer from 'components/grid/EditorialContainer';
import { HeroWithConfetti } from 'components/Hero';

const FullCmsPage = ({ title, content }) => (
  <>
    <HeroWithConfetti title={title} />
    <EditorialContainer justifyContent="center">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </EditorialContainer>
  </>
);

export default FullCmsPage;
